export default {
    af_ZA: { english: 'Afrikaans', local: 'Afrikaans', readMore: 'Read more' },
    am_ET: { english: 'Amharic', local: 'አማርኛ', readMore: 'Read more' },
    ar_AE: { english: 'Arabic', local: 'العربية', readMore: 'Read more' },
    ar_EG: { english: 'Arabic (Egypt)', local: 'العربية (مصر)', readMore: 'Read more' },
    ar_SA: { english: 'Arabic (Saudi Arabia)', local: 'العربية', readMore: 'Read more' },
    bg_BG: {
        english: 'Bulgarian',
        local: 'български',
        readMore: 'Прочетете още',
    },
    bn_BD: { english: 'Bengali', local: 'বাংলা', readMore: 'Read more' },
    ca_ES: { english: 'Catalan', local: 'Catalan', readMore: 'Read more' },
    cs_CZ: { english: 'Czech', local: 'Čeština', readMore: 'Přečtěte si více' },
    cy_GB: { english: 'Welsh', local: 'Cymraeg', readMore: 'Read more' },
    da_DK: { english: 'Danish', local: 'Dansk', readMore: 'Læs mere' },
    de_DE: { english: 'German', local: 'Deutsch', readMore: 'Mehr lesen' },
    el_GR: {
        english: 'Greek',
        local: 'Ελληνικά',
        readMore: 'Διαβάστε περισσότερα',
    },
    en_US: { english: 'English', local: 'English', readMore: 'Read more' },
    es_ES: { english: 'Spanish', local: 'Español', readMore: 'Leer más' },
    es_MX: { english: 'Spanish (Mexico)', local: 'Español (México)', readMore: 'Leer más' },
    et_EE: {
        english: 'Estonian',
        local: 'Eesti keel',
        readMore: 'Lugege lähemalt',
    },
    eu_ES: { english: 'Basque', local: 'Basque', readMore: 'Leer más' },
    fi_FI: { english: 'Finnish', local: 'Suomi', readMore: 'Lue lisää' },
    fr_CA: {
        english: 'French (Canada)',
        local: 'Français (Canada)',
        readMore: 'Read more',
    },
    fr_FR: {
        english: 'French (France)',
        local: 'Français (France)',
        readMore: 'Lire la suite',
    },
    gl_ES: { english: 'Galician', local: 'Galician', readMore: 'Read more' },
    he_IL: { english: 'Hebrew', local: 'עִבְרִית', readMore: 'Read more' },
    hi_IN: { english: 'Hindi', local: 'िन्दी', readMore: 'Read more' },
    hr_HR: {
        english: 'Croatian',
        local: 'Hrvatski',
        readMore: 'Pročitajte više',
    },
    ht_HT: {
        english: 'Haitian Creole',
        local: 'kreyòl ayisyen',
        readMore: 'Read more',
    },
    hu_HU: {
        english: 'Hungarian',
        local: 'Magyar',
        readMore: 'Olvasson tovább',
    },
    in_ID: {
        english: 'Indonesian',
        local: 'Bahasa Indonesia',
        readMore: 'Read more',
    },
    is_IS: { english: 'Icelandic', local: 'Íslenska', readMore: 'Read more' },
    it_IT: { english: 'Italian', local: 'Italiano', readMore: 'Leggi di più' },
    ja_JP: { english: 'Japanese', local: '日本語', readMore: '詳細' },
    ko_KR: { english: 'Korean', local: '한국어', readMore: '더 읽기' },
    kl_GL: { english: 'Kalaallisut', local: 'Kalaallisut', readMore: 'Read more' },
    km_KH: { english: 'Khmer', local: 'ខ្មែរ', readMore: 'Read more' },
    lt_LT: {
        english: 'Lithuanian',
        local: 'Lietuvių',
        readMore: 'Skaityti daugiau',
    },
    lv_LV: { english: 'Latvian', local: 'Latviešu', readMore: 'Lasīt vairāk' },
    lo_LA: { english: 'Lao', local: 'ລາວ', readMore: 'Read more' },
    mg_MG: { english: 'Malagasy', local: 'Malagasy', readMore: 'Read more' },
    mh_MH: {
        english: 'Marshallese',
        local: 'Kajin M̧ajeļ',
        readMore: 'Read more',
    },
    mi_NZ: { english: 'Māori', local: 'Māori', readMore: 'Read more' },
    mk_MK: { english: 'Macedonian', local: 'Македонски', readMore: 'Read more' },
    mn_MN: { english: 'Mongolian', local: 'монгол', readMore: 'Read more' },
    mr_IN: { english: 'Marathi', local: 'मराठी', readMore: 'Read more' },
    ms_MY: { english: 'Malay', local: 'Bahasa Melayu', readMore: 'Read more' },
    ne_NP: { english: 'Nepali', local: 'नेपाली', readMore: 'Read more' },
    nl_NL: { english: 'Dutch', local: 'Nederlands', readMore: 'Lees meer' },
    no_NO: { english: 'Norwegian', local: 'Norsk', readMore: 'Les mer' },
    pl_PL: { english: 'Polish', local: 'Polski', readMore: 'Więcej' },
    pt_BR: {
        english: 'Portuguese (Brazil)',
        local: 'Português (Brasil)',
        readMore: 'Ler mais',
    },
    pt_PT: {
        english: 'Portuguese (Portugal)',
        local: 'Português (Portugal)',
        readMore: 'Ler mais',
    },
    ro_RO: { english: 'Romanian', local: 'Română', readMore: 'Citiți mai mult' },
    ru_RU: { english: 'Russian', local: 'Русский', readMore: 'Читать дальше' },
    si_LK: { english: 'Sinhala', local: 'සිංහල', readMore: 'Read more' },
    sk_SK: {
        english: 'Slovak',
        local: 'Slovenský',
        readMore: 'Prečítajte si viac',
    },
    sl_SI: {
        english: 'Slovenian',
        local: 'Slovenščina',
        readMore: 'Preberi več',
    },
    so_SO: { english: 'Somali', local: 'Af-Soomaali', readMore: 'Read more' },
    sr_RS: { english: 'Serbian', local: 'Српски', readMore: 'Pročitaj više' },
    sv_SE: { english: 'Swedish', local: 'Svenska', readMore: 'Läs mer' },
    sq_AL: { english: 'Albanian', local: 'Shqip', readMore: 'Read more' },
    ta_IN: { english: 'Tamil', local: 'Tamil', readMore: 'Read more' },
    th_TH: { english: 'Thai', local: 'ภาษาไทย', readMore: 'อ่านเพิ่มเติม' },
    tl_PH: { english: 'Tagalog', local: 'ᜏᜒᜃᜅ᜔ ᜆᜄᜎᜓᜄ᜔', readMore: 'Read more' },
    tr_TR: {
        english: 'Turkish',
        local: 'Türkçe',
        readMore: 'Daha fazlasını oku',
    },
    uk_UA: {
        english: 'Ukrainian',
        local: 'Українська',
        readMore: 'Прочитати більше',
    },
    ur_PK: { english: 'Urdu', local: 'اُردُو', readMore: 'مزید پڑھیں' },
    vi_VN: { english: 'Vietnamese', local: 'Tiếng Việt', readMore: 'Đọc thêm' },
    zh_CN: { english: 'Chinese', local: '简体中文', readMore: '阅读更多' },
    zh_HK: { english: 'Chinese traditional', local: '繁體中文', readMore: '閱讀更多' },
    zu_ZA: { english: 'Zulu', local: 'isiZulu', readMore: 'Read more' },
};
